import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import BasicCheckbox from '../../forms/fields/BasicCheckbox';
import BasicFileInput from '../../forms/fields/BasicFileInput';
import BasicRadioList from '../../forms/fields/BasicRadioList';
import Textarea from '../../forms/fields/Textarea';

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    setFieldValue: PropTypes.func,
    formSubmitting: PropTypes.bool,
    questions: PropTypes.array,
    answers: PropTypes.array,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentProps = this.props;

    if (currentProps.formSubmitting && !nextProps.formSubmitting) {
      currentProps.resetForm();
    }
  }

  render() {
    const { questions, isSubmitting } = this.props;

    return (
      <form className="m-login__form m-form" onSubmit={this.props.handleSubmit}>
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__body">
                {questions.map((question) => (
                  <div className="form-group m-form__group row" key={question.id}>
                    {question.type === 'file' && [
                      <label
                        key="label"
                        className="col-lg-6 col-form-label prose"
                        dangerouslySetInnerHTML={{ __html: question.question }}
                      />,
                      <div key="form" className="col-lg-6">
                        <BasicFileInput
                          {...this.props}
                          handleChange={(e) => {
                            this.props.setFieldValue('question_' + question.id, e.target.files);
                          }}
                          name={'question_' + question.id}
                          type="file"
                        />
                      </div>,
                    ]}

                    {question.type === 'confirmation' && (
                      <div className="col-lg-12">
                        <BasicCheckbox
                          {...this.props}
                          name={'question_' + question.id}
                          label={question.question}
                          allowHTML
                        />
                      </div>
                    )}

                    {question.type === 'polar_question' && [
                      <label
                        key="label"
                        className="col-lg-6 col-form-label prose"
                        dangerouslySetInnerHTML={{ __html: question.question }}
                      />,
                      <div key="form" className="col-lg-6">
                        <BasicRadioList
                          {...this.props}
                          name={'question_' + question.id}
                          options={[
                            {
                              value: 'yes',
                              label: 'Yes',
                            },
                            {
                              value: 'no',
                              label: 'No',
                            },
                          ]}
                        />
                      </div>,
                    ]}

                    {question.type === 'text' && [
                      <label
                        key="label"
                        className="col-lg-6 col-form-label prose"
                        dangerouslySetInnerHTML={{ __html: question.question }}
                      />,
                      <div key="form" className="col-lg-6">
                        <Textarea {...this.props} name={'question_' + question.id} />
                      </div>,
                    ]}
                  </div>
                ))}
              </div>
              <div className="m-portlet__foot">
                <div className="row align-items-center">
                  <div className="col-lg-12 m--align-right">
                    <button
                      className={
                        'btn m-btn btn-secondary m--margin-left-10' +
                        (isSubmitting ? ' m-btn--custom m-loader m-loader--light m-loader--left' : '')
                      }
                      disabled={isSubmitting}
                    >
                      <Trans>Update</Trans>
                    </button>
                    <span className="m--margin-left-10">
                      <Trans>or</Trans>{' '}
                      <Link to="/company/employees" className="m-link m--font-bold">
                        <Trans>Cancel</Trans>
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const CompanySecurityQuestionsForm = withFormik({
  mapPropsToValues: (props) => {
    const { questions, answers } = props;
    let values = {};

    questions.forEach((question) => {
      const answer = answers.filter((answer) => answer.safetyQuestionId === question.id);
      values['question_' + question.id] = answer.length > 0 ? answer[0].answer : '';
    });

    return values;
  },
  validate: (values, props) => {
    const { questions } = props;
    let errors = {};

    questions.forEach((question) => {
      if (!values['question_' + question.id] || values['question_' + question.id] === '') {
        errors['question_' + question.id] = 'required';
      }
    });

    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  },
})(InnerForm);

export default CompanySecurityQuestionsForm;
